import { useContext } from 'react';
import { UserSessionContext } from '@/providers/UserSessionContext';

type RestrictedComponentProps = {
  children?: React.ReactNode;
  alternativeComponent?: React.ReactNode;
};

const RestrictedComponent = ({ children, alternativeComponent }: RestrictedComponentProps) => {
  const { user } = useContext(UserSessionContext);
  return <>{user && user.is_staff ? children : alternativeComponent}</>;
};

export default RestrictedComponent;
